module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_horie-dadc7daab58c8cd247cd6bcd4e9b75c1.jpg";